exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".frc-button{font-size:12px !important;height:25px !important}", ""]);
